import { DocumentAccountExtractDetails } from 'services/ApiService/Franfinance/FranfinanceApiClient';
import { Reducer } from 'store/configureStore';
import { ApiRequest } from 'store/sharedModels';

export const endOfContractEarlyRedemptionInitialState = {
    results: {} as { [id: string]: ApiRequest<DocumentAccountExtractDetails> },
} as const;

type DocumentAccountExtractState = typeof endOfContractEarlyRedemptionInitialState;

export const EndOfContractEarlyRedemptionReducer: Reducer<DocumentAccountExtractState> = (state = endOfContractEarlyRedemptionInitialState, action) => {
    switch (action.type) {

        case '@CUSTOMER_REQUEST_DETAILS/END_OF_CONTRACT/EARLY_REDEMPTION/GET':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: true,
                        didInvalidate: true,
                    },
                },
            };
        case '@CUSTOMER_REQUEST_DETAILS/END_OF_CONTRACT/EARLY_REDEMPTION/GET_SUCCESS':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: false,
                    },
                },
            };
        case '@CUSTOMER_REQUEST_DETAILS/END_OF_CONTRACT/EARLY_REDEMPTION/GET_FAILURE':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: true,
                    },
                },
            };
        case '@CUSTOMER_SERVICE_DETAILS_RESPONSE/INSTRUCTION/SUBMIT_SUCCESS':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: true,
                    },
                },
            };
        case '@CUSTOMER_SERVICE_DETAILS_RESPONSE/NON_COMPLIANCE/SUBMIT_SUCCESS':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: true,
                    },
                },
            };
        default:
            return state;

    }
};